import { Box, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Comparison } from "../../../types";
import LoadingSkeleton from "../../consteNew/Skeleton/CompareLoadingSkeleton";
import {
  ComparisonArrow,
  ComparisonBar,
  ComparisonBarContainer,
  ComparisonContent,
  ComparisonDashedLine,
  ComparisonDescription,
  ComparisonDisclaimer,
  ComparisonHeaderContainer,
  ComparisonLeftColumn,
  ComparisonLogo,
  ComparisonPlanName,
  ComparisonPriceText,
  ComparisonPriceUnit,
  ComparisonRightColumn,
  ComparisonRow,
  ComparisonSignUpButton,
  ComparisonTitle,
  ComparisonTitleText,
  ComparisonWrapper,
} from "../styles/components";
import ComparsionModal from "../../consteNew/ComparsionModal";
import { handleSignUp } from "../../consteNew/utils";
import { Plan, usePlanContext } from "../../consteNew/context/planContext";
import { getCurrentPromoCode } from "../../../utils/promoCodeUtils";

export default function ComparisonSectionTx() {
  const location = useLocation();
  const routeBasedPromoCode = getCurrentPromoCode(location.pathname);
  const {
    plans,
    zipCode,
    utility,
    comparePlansLoading,
    compareData,
    plansLoading,
    bestValuePlan,
  } = usePlanContext();
  const navigate = useNavigate();
  const maxValue = Math.max(...compareData.map((c) => c.value));
  const [showComparisonCardModal, setShowComparisonCardModal] = useState(false);
  const [selectComparisonCardModal, setSelectComparisonCardModal] =
    useState<Comparison>();
  if (plansLoading) return <LoadingSkeleton />;

  const handleComparisonCardModal = (plan: Comparison) => {
    setShowComparisonCardModal(true);
    setSelectComparisonCardModal(plan);
  };
    const twelveMonthConstoPlan = plans.filter((p) => {
    return p?.plan_id === compareData[0]?.plan_id;
  })[0];


  return comparePlansLoading ? (
    <LoadingSkeleton />
  ) : (
    <>
      {compareData && compareData.length > 1 ? (
        <ComparisonWrapper id="comparison-section">
          <ComparisonHeaderContainer>
            <ComparisonTitle>
              <ComparisonTitleText>
               Compare your rate against top Texas providers
              </ComparisonTitleText>
              <ComparisonArrow
                src="/images/constenewImg/ei_arrow-right.svg"
                alt="arrow"
              />
            </ComparisonTitle>
          </ComparisonHeaderContainer>
          <ComparisonContent>
            <ComparisonLeftColumn>
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "24px",
                    alignSelf: "stretch",
                  }}
                >
                  <ComparisonDescription>
                    With our {twelveMonthConstoPlan?.plan_name} plan, you could save up
                    to {twelveMonthConstoPlan?.savings} per year compared to the highest
                    available offer.
                  </ComparisonDescription>
                  <ComparisonSignUpButton
                    variant="contained"
                    onClick={() => {
                      localStorage.setItem(
                        "selectProduct",
                        JSON.stringify(twelveMonthConstoPlan),
                      );
                      localStorage.setItem("utility", JSON.stringify(utility));
                      localStorage.setItem("promoCode", routeBasedPromoCode);
                      handleSignUp(
                        twelveMonthConstoPlan as Plan,
                        zipCode,
                        utility,
                        navigate,
                        location,
                      );
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#FFF",
                        fontFamily: "Inter",
                        fontSize: { xs: "14px", md: "16px" },
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "20px",
                        letterSpacing: "-0.15px",
                      }}
                    >
                      Sign up with Constellation
                    </Typography>
                  </ComparisonSignUpButton>
                </Box>
              </>
            </ComparisonLeftColumn>
            <ComparisonRightColumn>
              <>
                {compareData.map((plan, idx) => {
                  const widthPercent = `${(plan.value / maxValue) * 85}%`;
                  const delay = 0.3 + idx * 0.3;
                  return (
                    <ComparisonRow key={idx}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <ComparisonLogo
                          src={plan.logoSrc}
                          alt="brand"
                          grayscale={idx > 0}
                        />
                      </Box>
                      <ComparisonBarContainer>
                        <ComparisonBar
                          color={plan.color}
                          delay={delay}
                          width={widthPercent}
                        />
                        <ComparisonDashedLine />
                        <ComparisonPriceText>
                          {plan.value}
                          {plan.unit}
                          <ComparisonPriceUnit>per kWh</ComparisonPriceUnit>
                        </ComparisonPriceText>
                        <ComparisonPlanName
                          style={{ cursor: "pointer" }}
                          onClick={() => handleComparisonCardModal(plan)}
                        >
                          {plan.plan_name}
                        </ComparisonPlanName>
                      </ComparisonBarContainer>
                    </ComparisonRow>
                  );
                })}
                <ComparisonDisclaimer>
                  The comparisons above are to companies that we believe meet
                  our standard of quality, and do not represent all plans
                  available from us or from the competitors listed. This is a
                  snapshot of plans as of {new Date().toLocaleDateString()} and
                  are subject to change based on market conditions and provider
                  offerings.
                </ComparisonDisclaimer>
              </>
            </ComparisonRightColumn>
          </ComparisonContent>
        </ComparisonWrapper>
      ) : null}

      {showComparisonCardModal && selectComparisonCardModal && (
        <ComparsionModal
          selectComparisonCardModal={selectComparisonCardModal}
          show={showComparisonCardModal}
          handleClose={() => setShowComparisonCardModal(false)}
        />
      )}
    </>
  );
}
